import {
	commentFrameSideBarDefinition,
	commentFrameStickerSideBarDefinition
} from "~/js/nodes/local/logic/commentFrame";
import { queryClient } from "~/solidJs/shared/api/queryClient";
import { createNeuralnetsOptions } from "../nodes/neural-networks";

const customObjectsLibrary = {
	[commentFrameSideBarDefinition.globalId]: commentFrameSideBarDefinition,
	[commentFrameStickerSideBarDefinition.globalId]: commentFrameStickerSideBarDefinition
};

export const getNodeLibrary = () => {
	return { customObjectsLibrary };
};

export const getNodeDefinitionInLocalOrRemote = (globalId) => {
	const opts = createNeuralnetsOptions();
	const couldNodeList = queryClient.getQueryData(opts.queryKey);
	return couldNodeList?.[globalId];
};

/**
 *
 * @param {*} globalId
 * @returns {import( "../nodes/node-definition").NodeDefinition}
 */
export const getSyncNodeDefinition = (globalId) => {
	const def = getNodeDefinitionInLocalOrRemote(globalId);
	return def?.definition;
};

export const getDefinitionOrAwait = async (globalId) => {
	const def = getNodeDefinitionInLocalOrRemote(globalId);
	if (!def) return;
	if (def.promise) {
		return def.promise;
	}
	return def.definition;
};
